module.exports = new __parcel__URL__("peter.288a15c5.avif").toString();